import {ConvertRequest} from './ConvertRequest';
import {ConvertResponse} from './ConvertResponse';
import {BaseService} from '@utex/base-api-sdk';


export class ConvertClientService extends BaseService {
    protected clientName: string = 'ConvertClientService'
    
    convert = this.createRest<ConvertResponse,ConvertRequest>('/rest/grpc/com.unitedtraders.luna.mobilegateway.convert.ConvertClientService.convert',true,'schema.json#/properties/convertRequest','schema.json#/properties/convertResponse','ConvertClientService/convert');

}